// ============================================================
// section-pa-home.js — ParticleActive custom home sections
// ============================================================

// ===== Custom Element: <pa-hero-carousel> =====
 



document.addEventListener('DOMContentLoaded', function () {

    // ===== HERO CAROUSEL =====
  document.querySelectorAll('pa-hero-carousel').forEach(function (carousel) {
    var track    = carousel.querySelector('.pa-carousel-track');
    var slides   = carousel.querySelectorAll('.pa-carousel-slide');
    var dots     = carousel.querySelectorAll('.pa-carousel-dot');
    var autoplay = parseInt(carousel.getAttribute('autoplay'), 10) || 0;
    var current  = 0;
    var timer    = null;

    if (slides.length <= 1) return;

    function goTo(index) {
      var len = slides.length;
      if (index < 0) index = len - 1;
      if (index >= len) index = 0;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d) { d.classList.remove('pa-active'); });
      if (dots[index]) dots[index].classList.add('pa-active');
      current = index;
    }

    function next() { goTo(current + 1); }

    // 统一重启定时器，手动操作后调用
    function restartTimer() {
      if (timer) clearInterval(timer);
      if (autoplay > 0 && slides.length > 1) {
        timer = setInterval(next, autoplay);
      }
    }

    // ===== Touch swipe =====
    var imageArea = carousel.querySelector('.pa-carousel-image-area');
    var startX = 0;
    var isSwiping = false;

    if (imageArea) {
      imageArea.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isSwiping = false;
      }, { passive: true });

      imageArea.addEventListener('touchmove', function (e) {
        if (Math.abs(e.touches[0].clientX - startX) > 10) {
          isSwiping = true;
        }
      }, { passive: true });

      imageArea.addEventListener('touchend', function (e) {
        if (!isSwiping) return;
        var diff = startX - e.changedTouches[0].clientX;
        if (diff > 50) {
          goTo(current + 1);
          restartTimer();
        } else if (diff < -50) {
          goTo(current - 1);
          restartTimer();
        }
      }, { passive: true });
    }

    // ===== Dot click =====
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index, 10));
        restartTimer();
      });
    });

    // ===== 启动自动轮播（只启动一次，不需要 mouseenter/mouseleave 暂停）=====
    if (autoplay > 0 && slides.length > 1) {
      timer = setInterval(next, autoplay);
    }
  });

  // ===== PRODUCT LIST SWIPER (outer) =====
  document.querySelectorAll('.swiper-pa-items').forEach(function (container) {
    // First, init inner product image swipers (each card's own swiper)
    container.querySelectorAll('.pa-card-swiper').forEach(function (cardSwiper) {
      if (cardSwiper.querySelectorAll('.swiper-slide').length > 1) {
        var innerSwiper = new Swiper(cardSwiper, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: cardSwiper.querySelector('.swiper-pagination'),
            clickable: true,
            dynamicBullets: true,
          },
          navigation: {
            nextEl: cardSwiper.querySelector('.swiper-button-next'),
            prevEl: cardSwiper.querySelector('.swiper-button-prev'),
          },
        });
       
        // Color swatch click — switch to variant image
        var cardProduct = cardSwiper.closest('.pa-card-product');
        if (cardProduct) {
          // Hover: switch to second image on mouseenter
          if (cardProduct.dataset.secondaryImage === 'true') {
            var slideCount = cardSwiper.querySelectorAll('.swiper-slide').length;
            if (slideCount > 1) {
              cardProduct.addEventListener('mouseenter', function () {
                innerSwiper.slideTo(1, 300);
              });
              cardProduct.addEventListener('mouseleave', function () {
                innerSwiper.params.speed = 0;
                innerSwiper.slideTo(0, 0);
              });
            }
          }

          var swatches = cardProduct.querySelectorAll('.pa-color-swatch');
          swatches.forEach(function (sw) {
            sw.addEventListener('click', function () {
              var idx = parseInt(this.dataset.slide, 10);
              if (!isNaN(idx) && idx >= 0) {
                innerSwiper.slideTo(idx);
              }
              swatches.forEach(function (s) { s.classList.remove('pa-active'); });
              this.classList.add('pa-active');
            });
          });
        }
      }
    });

    // Then init outer product list swiper
    var desktopSlides = parseFloat(container.dataset.desktop) || 4;
    var mobileSlides = parseFloat(container.dataset.mobile) || 2;
    var navEl = container.querySelector('.swiper-pa-nav');
    var prevBtn = container.querySelector('.swiper-pa-prev');
    var nextBtn = container.querySelector('.swiper-pa-next');

    new Swiper(container, {
      slidesPerView: 2,
      spaceBetween: 10,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
        1200: {
          slidesPerView: desktopSlides,
          spaceBetween: 16,
          navigation: false,
        },
      },
    });

    // Show/hide nav container based on breakpoint
    function updateNavVisibility() {
      if (window.innerWidth < 1200) {
        navEl.style.display = 'flex';
      } else {
        navEl.style.display = 'none';
      }
    }
    updateNavVisibility();
    window.addEventListener('resize', updateNavVisibility);
  });

  // ===== SCROLL FADE IN =====
  var fadeSelectors = '.pa-product-card, .pa-dream-step, .pa-service-item, .pa-testimonial-card, .pa-faq-item, .pa-section-title, .pa-section-subtitle';
  var fadeEls = document.querySelectorAll(fadeSelectors);
  fadeEls.forEach(function (el) { el.classList.add('pa-fade-in'); });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pa-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    fadeEls.forEach(function (el) { observer.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('pa-visible'); });
  }

  console.log('[PA] Sections loaded ✓');
});
